/**
 * Convert string with lowdash e.g(string_example) to string with regular dash e.g(string-example)
 * @param text string
 * @returns converted string
 */
export const convertLowDashToDash = (text) => ((text === null || text === void 0 ? void 0 : text.split('_').join('-')) || '');
